export default [
  {
    path: '/:lang/login',
    name: 'login',
    props: true,
    component: () => import('@/views/auth/Login.vue')
  }
]
